import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthProvider';
import { Menu, X } from 'lucide-react'; // ✅ icon from lucide-react

const AdminNavbar = () => {
  const { user, logout } = useAuth();
  const [menuOpen, setMenuOpen] = useState(false);

  // Determine where "Admin Panel" should go
  const panelLink =
    user?.role === 'admin'
      ? '/admin/products'
      : user?.role === 'factory'
        ? '/factory'
        : '/customer-service-dashboard';

  const handleMenuClose = () => setMenuOpen(false);

  return (
    <nav className="bg-gray-800 text-white shadow-md w-full">
      <div className="flex items-center justify-between w-full py-2 px-4">
        {/* Logo / Panel Redirect */}
        <Link to={panelLink} className="font-semibold text-xl">
          Admin Panel
        </Link>

        {/* Mobile Toggle Button */}
        <button
          className="md:hidden"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle Menu"
        >
          {menuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>

        {/* Links (desktop) */}
        <div className="hidden md:flex gap-4 text-sm items-center">
          {user?.role === 'admin' && (
            <>
              <Link to="/admin/products" className="hover:text-gray-300">Products</Link>
              <Link to="/admin/add-product" className="hover:text-gray-300">Add Product</Link>
              <Link to="/admin/users" className="hover:text-gray-300">Manage Users</Link>
            </>
          )}

          {(user?.role === 'admin' || user?.role === 'customer-service') && (
            <>
              <Link to="/customer-service-dashboard" className="hover:text-gray-300">Customer Service</Link>
              <Link to="/admin/notify-requests" className="hover:text-gray-300">Requests</Link>
              <Link to="/admin-settings" className="hover:text-gray-300">Gold Rate</Link>
            </>
          )}

          {(user?.role === 'admin' || user?.role === 'factory') && (
            <Link to="/factory" className="hover:text-gray-300">Factory</Link>
          )}

          {(user?.role === 'admin' || user?.role === 'factory' || user?.role === 'customer-service') && (
            <>
              <Link to="/order-form" className="hover:text-gray-300">Add Order</Link>
              <Link to="/guarantee-search" className="hover:text-gray-300">Guarantee</Link>
            </>
          )}

          {/* Role + Logout */}
          <span className="text-xs bg-gray-700 px-2 py-1 rounded">Role: {user?.role}</span>
          <button onClick={logout} className="text-red-400 hover:text-red-200">Logout</button>
        </div>
      </div>

      {/* Links (mobile dropdown) */}
      {menuOpen && (
        <div className="md:hidden flex flex-col gap-3 px-4 py-4 text-sm bg-gray-800 text-white border-t border-gray-700">
          {user?.role === 'admin' && (
            <>
              <Link to="/admin/products" onClick={handleMenuClose}>Products</Link>
              <Link to="/admin/add-product" onClick={handleMenuClose}>Add Product</Link>
              <Link to="/admin/users" onClick={handleMenuClose}>Manage Users</Link>
            </>
          )}

          {(user?.role === 'admin' || user?.role === 'customer-service') && (
            <>
              <Link to="/customer-service-dashboard" onClick={handleMenuClose}>Customer Service</Link>
              <Link to="/admin/notify-requests" onClick={handleMenuClose}>Requests</Link>
              <Link to="/admin-settings" onClick={handleMenuClose}>Gold Rate</Link>
            </>
          )}

          {(user?.role === 'admin' || user?.role === 'factory') && (
            <Link to="/factory" onClick={handleMenuClose}>Factory</Link>
          )}

          {(user?.role === 'admin' || user?.role === 'factory' || user?.role === 'customer-service') && (
            <>
              <Link to="/order-form" onClick={handleMenuClose}>Add Order</Link>
              <Link to="/guarantee-search" onClick={handleMenuClose}>Guarantee</Link>
            </>
          )}

          <div className="flex items-center justify-between text-xs mt-2 px-1">
            <span className="bg-gray-700 px-2 py-1 rounded">Role: {user?.role}</span>
            <button onClick={() => { handleMenuClose(); logout(); }} className="text-red-400">Logout</button>
          </div>
        </div>
      )}

    </nav>
  );
};

export default AdminNavbar;
